import {ErrorComponent} from '@refinedev/mui';
import {lazy} from 'react';
import {Route, Routes as RouterRoutes} from 'react-router';

const Index = lazy(() => import('@pages/bdese/home'));
const ListChecklist = lazy(() => import('@pages/bdese/checklist/list-checklist'));
const CreateChecklist = lazy(() => import('@pages/bdese/checklist/create-checklist'));
const EditChecklist = lazy(() => import('@pages/bdese/checklist/edit-checklist'));
const ListSubthematic = lazy(() => import('@pages/bdese/subthematic/list-subthematic'));
const ShowSubthematic = lazy(() => import('@pages/bdese/subthematic/show-subthematic'));
const CreateHelp = lazy(() => import('@pages/bdese/help/create-help'));
const EditHelp = lazy(() => import('@pages/bdese/help/edit-help'));

export const Routes = () => {
  return (
    <RouterRoutes>
      <Route index element={<Index />} />
      <Route path="checklists">
        <Route index element={<ListChecklist />} />
        <Route path="new" element={<CreateChecklist />} />
        <Route path="edit/:id" element={<EditChecklist />} />
      </Route>
      <Route path="subthematics">
        <Route index element={<ListSubthematic />} />
        <Route path=":id" element={<ShowSubthematic />} />
        <Route path=":subthematicId/helps">
          <Route path="new" element={<CreateHelp />} />
          <Route path="edit/:id" element={<EditHelp />} />
        </Route>
      </Route>
      <Route path="*" element={<ErrorComponent />} />
    </RouterRoutes>
  );
};
